import SkeletonSpinner from '../SkeletonSpinner/SkeletonSpinner.vue';

import { createNamespacedHelpers } from 'vuex';
const historyMapper = createNamespacedHelpers('history');

export default {
	name: 'SkeletonLoadingImage',

	components: {
		SkeletonSpinner,
	},

	data() {
		return {
			isSkeletonLoading: true,
			onHover: false,
		};
	},

	props: {
		image: {
			type: Object,
		},

		GOOD_CLASS: {
			type: String,
		},
		isDetectedImage: {
			type: Boolean,
			default: true,
		}
	},

	computed: {
		...historyMapper.mapState(['noCheckBox']),
	},

	methods: {
		onImageClick() {
			this.$emit('choose-image');
		},
		onImageLoad() {
			this.isSkeletonLoading = false;
		},
		onMouseEnter() {
			this.onHover = true;
		},
		onMouseLeave() {
			this.onHover = false;
		},
	},
};
